import { PageLocatorMap } from '../types/PageLocatorMap';

export const signInPage = {
  alert: {
    error: 'signin-page.alert.error',
    info: 'signin-page.alert.info',
    signupLink: 'signin-page.alert.signup-link',
  },
  footer: {
    root: 'signin-page.footer.root',
  },
  form: {
    h1: 'signin-page.form.heading1',
    h2: 'signin-page.form.heading2',
    phoneInput: 'signin-page.form.phone-input',
    phoneInputError: 'signin-page.form.phone-error',
    root: 'signin-page.form.root',
    signupLink: 'signin-page.form.signup-link',
    submitButton: 'signin-page.form.submit-button',
  },
  header: {
    root: 'signin-page.header.root',
    signupLink: 'signin-page.header.signup-link',
  },
} as const satisfies PageLocatorMap;
